import Collapse from './Collapse';
export { Collapse };
export default Collapse;
